import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    filters: {
        idFilial: 0,
        member: "",
        therapist: "",
        idEstado: 2,
    },
    listFiliales: [],
    listEstados: [],
    results: [],
}

export const therapySearchSlice = createSlice({
    name: "therapySearch",
    initialState,
    reducers: {
        setValue: (state, action) => {
            const { name, value } = action.payload;

            state.filters[name] = value;
        },
        setResults: (state, action) => {
            state.results = action.payload;
        },
        setFiliales: (state, action) => {
            state.listFiliales = action.payload;
        },
        setListEstados: (state, action) => {
            state.listEstados = action.payload;
        },
    },
});

export const { setValue, setResults, setFiliales, setListEstados } = therapySearchSlice.actions;
export default therapySearchSlice.reducer;
